import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'no-active-certificates-found',
  templateUrl: './no-active-certificates-found.component.html',
  styleUrls: ['./no-active-certificates-found.component.scss']
})
export class NoActiveCertificatesFoundComponent {
  @Output() goBackEmit = new EventEmitter<void>();

  goBack(): void {
    this.goBackEmit.emit();
  }
}
